import React, { Fragment, useEffect, useState } from "react";
import { Button, Card, CardBody, CardFooter } from 'reactstrap';
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import { useLocation, useNavigate } from "react-router";
import FllterInstellingenPlanning from "./FllterInstellingen";
import InstellingenForm from "./InstellingenForm";
import { ReactComponent as BackIcon } from "../../../../../assets/utils/images/svgs/arrow-left.svg";
import Loader from 'react-loaders';
import { toast } from "react-toastify";
import { debounce } from "../../../../../helperFunctions/index";
import { useContractFilter, useSaveContractFilter } from "Api/Coordinator/Instellingen";


const FllterInstellingen = ({ errorField }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const [filterValue, setFilterValue] = useState({});

    const { planning, iCommunityId, filterId, contractName } = location.state;

    const {
        trigger: getFilter,
        data: filterResponse,
        isMutating: isLoading,
    } = useContractFilter(!!filterId);

    const filterParams = {
        iCommunityId,
        filterId,
        role: planning === "Schoolplanning" ? "1" : "0",
    };

    const refreshFilterData = () => {
        if (!filterId) return;

        return getFilter({
            data: filterParams,
        });
    };

    useEffect(() => {
        refreshFilterData();
    }, [filterId, iCommunityId, planning]);

    useEffect(() => {
        if (filterResponse?.status) {
            setFilterValue(filterResponse.data);
        }
    }, [filterResponse]);
    useEffect(() => {
        refreshFilterData();
    }, [filterId, iCommunityId, planning]);


    const { trigger: saveFilterMutation } = useSaveContractFilter();

    const callApi = (field, value, setFieldError, setLoadingKeys) => {
        if (value === "") {
            setFieldError(field, "required");
            return;
        }

        const data = {
            iCommunityId,
            filterId,
            role: planning === "Schoolplanning" ? "1" : "0",
            ...(field ? { attr: field } : {}),
            [field]: value,
        };

        saveFilterMutation({
            method: "post",
            data,
        })
            .then((response) => {
                if (response?.status) {
                //    refreshFilters();
                    setFilterValue(prev => ({
                        ...prev,
                        ...response.data
                    }));
                }

                if (!response?.status) {
                    const errors = response?.data?.[field];

                    if (Array.isArray(errors)) {
                        toast.error(errors.join(","));
                    } else {
                        toast.error(errors || "Er is iets misgegaan");
                    }
                }
            })
            .catch((error) => {
                console.error("API error:", error);
                toast.error("Er is iets misgegaan");
            })
            .finally(() => {
                if (setLoadingKeys) {
                    setLoadingKeys((prev) => ({
                        ...prev,
                        [field]: false,
                    }));
                }
            });
    };

    const debouncedApiCall = debounce(callApi, 500);

    const handleFieldChange = (field, value, setFieldError) => {
        debouncedApiCall(field, value, setFieldError);
    };

    const handleIconFieldChange = (field, value, setLoadingKeys) => {
        callApi(field, value, null, setLoadingKeys);
    };

    return (
        <Fragment>
            <PageHeading
                useDefaultPath={false}
                additionalBreadcrumbs={[
                    {
                        label: "Instellingen",
                        href: "/#/c-instellingen"
                    },
                    {
                        label: "Contracttypen",
                        href: "/#/c-instellingen/contracttypen"
                    },
                    {
                        label: contractName || "Contracttype",
                        clickable: false
                    },
                    {
                        label: "Filterinstellingen",
                        clickable: false
                    },
                    {
                        label: filterValue?.name || "Filter",
                        clickable: false
                    }
                ]}
            />

            <TransitionOnLoad>
                {isLoading ? (
                    <Card className="main-card">
                        <CardBody className="d-flex flex-column">
                            <Loader
                                type="ball-grid-pulse"
                                className="mt-3 d-flex mx-auto justify-content-center"
                            />
                        </CardBody>
                    </Card>
                ) : (
                    <>
                        <div className='row contract-typen-view mb-5'>

                            <div className='col-xl-4 p-2'>
                                <FllterInstellingenPlanning
                                    data={filterValue}
                                    planning={planning}
                                    handleIconFieldChange={handleIconFieldChange}
                                    handleFieldChange={handleFieldChange}
                                />
                            </div>

                            <div className='col-xl-8 p-2'>
                                <InstellingenForm
                                    data={filterValue}
                                    handleIconFieldChange={handleIconFieldChange}
                                    handleFieldChange={handleFieldChange}
                                />
                            </div>

                        </div>

                        <div className="chat-layout-footer">
                            <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                                <div className="d-flex gap-3">
                                    <Button
                                        outline
                                        className="btn-outline-primary-blue ms-auto"
                                        onClick={() => navigate(-1)}
                                        type="button"
                                        color="primary"
                                    >
                                        <BackIcon />
                                    </Button>
                                </div>
                            </CardFooter>
                        </div>
                    </>
                )}
            </TransitionOnLoad>
        </Fragment>
    );
};

export default FllterInstellingen;